import { useQuery } from '@apollo/client';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react';
import ProductItem from '~/components/Items/ProductItem';
import { QUERY_SEARCH_BY_KEYWORD_GQL } from '~/data/search/gql';
import { SneakLaunch } from '~/services/sneaker-release/sneaker-release.type';
import { transformProductItems } from '~/utils/transform';

type RelatedProductProps = {
    product?: SneakLaunch;
    swiperProps?: SwiperProps;
    keyword?: string;
};

const RelatedProduct = ({ swiperProps, keyword, product }: RelatedProductProps) => {
    const { data: fetchReleaseProduct, loading: actualLoading } = useQuery<any>(QUERY_SEARCH_BY_KEYWORD_GQL, {
        variables: {
            search: keyword,
            filter: {},
            sort: {},
            pageSize: 10,
            currentPage: 1
        },
        notifyOnNetworkStatusChange: true
    });

    const actualProducts = transformProductItems(fetchReleaseProduct?.products?.items || []);

    return (
        <Swiper
            slidesPerView={1.25}
            spaceBetween={10}
            navigation={
                actualProducts.length > 4.5
                    ? {
                          enabled: true,
                          hideOnClick: true
                      }
                    : undefined
            }
            modules={[Navigation]}
            breakpoints={{
                768: {
                    slidesPerView: 3.5
                },
                1024: {
                    slidesPerView: 4.5
                }
            }}
            {...swiperProps}
        >
            {actualProducts.map((p, index) => {
                return (
                    <SwiperSlide key={index} className="h-auto">
                        <ProductItem data={p} params={{ b: product?.brandCode, p: index }} />
                    </SwiperSlide>
                );
            })}
        </Swiper>
    );
};

export default RelatedProduct;
